<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="1000" persistent scrollable>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="rounded-lg">
          <v-card-title class="pa-3 ml-3 mr-3">
            รายละเอียดประกาศ<v-spacer></v-spacer>
            <v-btn color="#077893" outlined @click="Fn_Close()">
              {{ $t("consentform.close") }}</v-btn
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap justify-center align-center ml-3 pa-1>
              <v-flex xs12 lg6 pt-3
                ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                {{ PolicyHeader }}
              </v-flex>
              <v-flex xs12 lg6 pt-3>
                <b>องค์กรที่ขอประกาศ : </b
                ><span v-if="$t('default') === 'th'">{{ BusinessNameTh }}</span>
                <span v-else>{{ BusinessNameEng }}</span>
              </v-flex>
              <v-flex xs12 lg6 pt-3
                ><b class="mr-2">เลขที่ประกาศ :</b>
                {{ DataAnnounce.AnnounceNO }}
              </v-flex>
              <v-flex xs12 lg6 pt-3>
                <b>ชื่อประกาศ: </b><span>{{ DataAnnounce.AnnounceName }}</span>
              </v-flex>
              <v-flex xs12 lg12 pt-5>
                <v-card outlined>
                  <v-card-title v-if="$t('default') === 'th'">
                    รายละเอียดนโยบาย
                  </v-card-title>
                  <v-card-title v-else> Policy detail </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center pa-1>
                      <v-flex xs12 lg12 text-left>
                        <div v-html="PolicyDetail"></div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <br />
          </v-card-text>
          <v-progress-linear
            indeterminate
            color="#077893"
            v-if="loadingDownloadData"
          ></v-progress-linear>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: {},
  props: ["show", "item"],
  data: function () {
    return {
      valid: true,
      Consent: [],
      DataAnnounce: [],
      itemsRequest: [],
      DataConsentStatus: [],
      PolicyHeader: "",
      PolicyName: "",
      PolicyDetail: "",
      BusinessNameTh: "",
      BusinessNameEng: "",
      Status: "",
      ShowStatus: true,
      loadingDownloadData: false,
      DialogGeneral: false,
      NameBtnSave: "ยืนยันตัวเลือกของฉัน",
      NameBtnSaveEng: "Confirm my choice",
      load: false,
    };
  },
  computed: {
    shower: {
      ...mapGetters(["DataGeneralConsent"]),
      ...mapGetters(["DataGroupConsent"]),
      ...mapGetters(["Business"]),
      _SendId: {
        get() {
          return this.DataGroupConsent.SendId || "-";
        },
      },
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  mounted() {},
  methods: {
    Fn_Close() {
      this.$emit("closeDialog");
    },
    Fn_ClearData() {
      this.Consent = [];
      this.DataAnnounce = [];
      this.itemsRequest = [];
      this.DataConsentStatus = [];
      this.PolicyHeader = "";
      this.PolicyName = "";
      this.PolicyDetail = "";
      this.BusinessNameTh = "";
      this.BusinessNameEng = "";
      this.Status = "";
      this.load = false;
    },
    async Fn_GetDataEmail() {
      this.Fn_ClearData();
      this.loadingDownloadData = true;
      var payload = {
        AnnounceId: this.item.AnnounceId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/DetailAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.show = true;

          if (response.data.Status === "OK") {
            this.DataAnnounce = response.data.Message[0];
            this.Consent = response.data.Message[0].Consent;
            this.PolicyName = response.data.Message[0].AnnounceName;
            this.PolicyHeader = response.data.Message[0].PolicyTitle;
            this.PolicyDetail = response.data.Message[0].PolicyDetails;
            this.BusinessNameTh = response.data.Message[0].BusinessNameTh;
            this.BusinessNameEng = response.data.Message[0].BusinessNameEng;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") + error.message || error,
            });
          }
        });
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.Fn_GetDataEmail();
      }
    },
  },
};
</script>
